var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "#000450",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M24 16.5H7.333M15.333 7.333l8.667 9-8.667 9"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDMyIDMyIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDA0NTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxsaW5lIHgxPSIyNCIgeTE9IjE2LjUiIHgyPSI3LjMzMzMzIiB5Mj0iMTYuNSIgc3Ryb2tlPSIjRkZGRkZGIi8+CjxwYXRoIGQ9Ik0xNS4zMzM0IDcuMzMzNUwyNCAxNi4zMzM1TDE1LjMzMzQgMjUuMzMzNSIgc3Ryb2tlPSIjRkZGRkZGIi8+Cjwvc3ZnPgo=";
export { SvgArrowWhite as ReactComponent };